export const isEverit = (id) => {
    return id == "661ff79d3bfa6900127fa677"
}

export const isNorthwell = (id) => {
    return id == "658ae13ac44c7400119c85c3"
}
